!function(t,e){e.behaviors.siteFooterV1={attach:function(e){var o=t(".js-site-footer-override",e);t(".js-footer-banner",e).html(o.last().html())}}}(jQuery,Drupal);
//# sourceMappingURL=site_footer_v1.js.map
